// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// const API_URL = `https://onlinecoursehost-prod.appspot.com`;

const API_URL = `https://api.onlinecoursehost.com`;

const isTestSubdomain = document.location.search?.includes(
  "tenantId=AD18N9JOvzXBs6RJduO7CP8rKmH2"
);

const authDomain = isTestSubdomain
  ? "onlinecoursehost-prod.firebaseapp.com"
  : "auth.onlinecoursehost.com";

export const environment = {
  production: true,
  test: false,
  useEmulators: false,
  domainName: "onlinecoursehost.com",
  platformCloudfrontDomain: "d8avu785lzlph.cloudfront.net",
  firebase: {
    apiKey: `AIzaSyAyRQSSmk_GPSGublhK1o-maKAOc3Srb5k`,
    authDomain,
    databaseURL: `https://onlinecoursehost-prod.firebaseio.com`,
    projectId: `onlinecoursehost-prod`,
    storageBucket: `onlinecoursehost-prod.appspot.com`,
    scormCourseBucket: `och-scorm-storage`,
    messagingSenderId: `856886270497`,
    appId: `1:856886270497:web:fc915dc187799f77a3e160`,
    measurementId: `G-M1M08EEVHP`,
  },
  google: {
    googleAnalyticsTrackingId: "GTM-TWLVLL2J", // google analytics tracking Id for admin@onlinecoursehost.com
    googleAdsGlobalTrackingId: "AW-378395162", // admin@onlinecoursehost.com google Ads conversions tracking ID, to be installed in every page of the website
  },
  authenticationUrl: `https://login.onlinecoursehost.com/login-page`,
  stripe: {
    // this is the Stripe ID of the platform Connect account
    // https://dashboard.stripe.com/settings/connect/onboarding-options/oauth
    stripeHostClientId: `ca_Gvq4QDeoVGeZ6ZhEVD54rigV2zkOiXgQ`,
    // This is the platform public key
    stripePublicKey: `pk_live_XzA4SNmBzT3XGfgM2mMkpIzO008maJqx45`,
  },
  paypal: {
    platformClientId:
      "Aegbhqmf6a_dLnoxc50-mhvtw7lbmy5os7uvvHGSmbj4ieH0t6ZLSL6L41s-hFziYS-uIUmuy7X3buqY",
  },
  rewardful: {
    platformAffiliateId: "98532a",
  },
  facebook: {
    platformPixelId: "501280424286480",
  },
  trackJS: {
    token: '760026820e58430e9ea205aab91d296d',
    enabled: true,
    application: 'onlinecoursehostcom',
    console: { display: true },
  },

  features: {
    partnerProgram: false,
    paypalIntegration: true,
    quizzes: false,
    drip: true,
    community: true,
    pageBuilder: true,
    communityBanUnbanMembers: true,
    upgradeButton: true,
    customCoursePaymentButton: true,
    analytics: true,
    analyticsSales: true,
    analyticsOrders: true,
    analyticsEngagement: false,
    courseToxicityCheck: true,
    userActivityLogs: true,
    cloneCourse: true,
    toxicityStatus: true,
    integrationStripeTax: false,
    socialMediaBar: true,
    emailTemplates: false,
    reviewSystem: false,
  },
  // REST API endpoints
  api: {
    saveEmailTemplatesUrl: `${API_URL}/api/save-email-templates`,
    updateCustomRoleUrl: `${API_URL}/api/update-custom-role`,
    importQuestionsBankUrl: `${API_URL}/api/questions-bank`,
    purchaseCourseUrl: `${API_URL}/api/purchase-course`,
    confirmCoursePurchasesUrl: `${API_URL}/api/confirm-course-purchases`,
    confirmBundlePurchasesUrl: `${API_URL}/api/confirm-bundle-purchases`,
    checkEnableStripeTaxUrl: `${API_URL}/api/stripe/check-and-enable-stripe-tax`,
    getPaymentMethodsConfigUrl: `${API_URL}/api/stripe/payment-methods-config`,
    purchaseBundleUrl: `${API_URL}/api/purchase-bundle`,
    customJwtUrl: `${API_URL}/api/custom-jwt`, // creates a custom authentication JWT for a given user. Used in the single-sign on solution for tenant domains
    stripeActivatePlanUrl: `${API_URL}/api/activate-plan`,
    stripeCancelPlanUrl: `${API_URL}/api/cancel-plan`,
    resourceAccessUrl: `${API_URL}/api/resource-access`, // load the file names only for which the user has access, which allows the user to for example play the video
    sendEmailUrl: `${API_URL}/api/send-email`,
    stripeConnectionUrl: `${API_URL}/api/stripe-connection`, // get the user credentials from Stripe and stores them in the DB
    stripeInitPricingPlansUrl: `${API_URL}/api/init-pricing-plans`,
    stripeUpdatePricingPLanUrl: `${API_URL}/api/update-pricing-plan`,
    stripeUpdateCardUrl: `${API_URL}/api/update-card`,
    fulfillFreeCouponUrl: `${API_URL}/api/fulfill-free-coupon`,
    redeemGiftUrl: `${API_URL}/api/redeem-gift`,
    newsletterUrl: `${API_URL}/api/newsletter`,
    downloadEmailsUrl: `${API_URL}/api/download-all-emails`,
    activateTeamMemberUrl: `${API_URL}/api/activate-team-member`,
    updateTeamSizeUrl: `${API_URL}/api/update-team-size`,
    createSubscriptionCouponUrl: `${API_URL}/api/create-subscription-coupon`,
    getStripeSettingsUrl: `${API_URL}/api/get-stripe-settings`,
    activateSubscriptionCouponUrl: `${API_URL}/api/activate-subscription-coupon`,
    updateInstructorPlanUrl: `${API_URL}/api/update-instructor-plan`,
    confirmPaypalPurchaseUrl: `${API_URL}/api/confirm-paypal-purchase`,
    createPaypalOrderUrl: `${API_URL}/api/create-paypal-order`,
    capturePaypalOrderUrl: `${API_URL}/api/capture-paypal-order`,
    getAvailableCurrenciesUrl: `${API_URL}/api/get-available-currencies`,
    purchaseInstructorLifetimePlanUrl: `${API_URL}/api/purchase-instructor-lifetime-plan`,
    activateMultiTierLifetimePlanUrl: `${API_URL}/api/activate-multi-tier-lifetime-plan`,
    createUserUrl: `${API_URL}/api/create-user`,
    activatePlatformLifetimeCouponUrl: `${API_URL}/api/activate-platform-lifetime-coupon`,
    sendPreviewEmailUrl: `${API_URL}/api/send-preview-email`,
    requestBulkEmailUrl: `${API_URL}/api/request-bulk-email`,
    sendBulkEmailUrl: `${API_URL}/api/send-bulk-email`,

    deleteStudentAndEnrollmentUrl: `${API_URL}/api/delete-student-and-enrollment`,
    setUserPermissionsUrl: `${API_URL}/api/set-admin-permissions`,
    activateCustomDomainCertificateUrl: `${API_URL}/api/activate-custom-domain-certificate`,
    deleteCustomDomainCertificateUrl: `${API_URL}/api/delete-custom-domain-certificate`,
    createCustomDomainUrl: `${API_URL}/api/create-custom-domain`,
    checkCustomDomainUrl: `${API_URL}/api/check-custom-domain`,
    resetCustomDomainUrl: `${API_URL}/api/reset-custom-domain`,
    createStripeCustomerPortalSession: `${API_URL}/api/create-customer-portal-session`,
    importScormCourseUrl: `${API_URL}/api/import-scorm-course`,
    scormUploadUrl: `${API_URL}/api/scorm-upload-url`,
    deleteScormZipUrl: `${API_URL}/api/delete-scorm-zip`,
    deleteScormCourseUrl: `${API_URL}/api/delete-scorm-course`,
    deleteCourseUrl: `${API_URL}/api/delete-course`,
    aiChatBotUrl: `${API_URL}/api/ai-chat`,
    // Ask-the-community AI (Modern community). COST CONTROL: the backend retrieves only the
    // top 5 matching posts per question and caches answers by normalised-question hash.
    communityAskAi: `${API_URL}/api/community/ask-ai`,
    upsertLessonNoteUrl: `${API_URL}/api/lesson-notes/upsert`,
    deleteLessonNoteUrl: `${API_URL}/api/lesson-notes/delete`,
    exportLessonNotesCsvUrl: `${API_URL}/api/lesson-notes/export-csv`,
    saveAiStudyUrl: `${API_URL}/api/lesson-notes/ai-study`,
    startAiChatSessionUrl: `${API_URL}/api/start-ai-chat-session`,
    continueAiChatSessionUrl: `${API_URL}/api/continue-ai-chat-session`,
    startStudentAiChatSessionUrl: `${API_URL}/api/start-student-ai-chat-session`,
    continueStudentAiChatSessionUrl: `${API_URL}/api/continue-student-ai-chat-session`,
    downloadStudentsUrl: `${API_URL}/api/download-students`,
    deleteMultipleStudentsUrl: `${API_URL}/api/delete-multiple-students`,
    manualEnrollStudentUrl: `${API_URL}/api/manual-enroll-student`,
    exportAffiliatePayoutCsv: `${API_URL}/api/extract-affiliate-commissions-csv`,
    purchaseLifetimeStorageUrl: `${API_URL}/api/purchase-lifetime-storage`,
    stripeCreateUpdateCommunityPlansUrl: `${API_URL}/api/stripe/create-update-community-plans`,
    stripeActivateCommunityPlanUrl: `${API_URL}/api/stripe/activate-community-plan`,
    stripeCreateUpdateRoomPlansUrl: `${API_URL}/api/stripe/create-update-room-plans`,
    stripeActivateRoomPlanUrl: `${API_URL}/api/stripe/activate-room-plan`,
    stripeCancelCommunityRoomPlanUrl: `${API_URL}/api/stripe/cancel-community-room-plan`,
    resetTenantPasswordEmailUrl: `${API_URL}/api/reset-tenant-password-email`,
    resetStudentPasswordEmailUrl: `${API_URL}/api/reset-student-password-email`,
    detectToxicCourseContentUrl: `${API_URL}/api/detect-toxic-course-content`,
    cloneCourseUrl: `${API_URL}/api/clone-course`,
    exportTransactionsCsvUrl: `${API_URL}/api/export-transactions-csv`,
    exportSalesPerMonthCsvUrl: `${API_URL}/api/export-sales-per-month-csv`,
    exportsalesPerProductTransactionsCsvUrl: `${API_URL}/api/export-sales-per-product-transactions-csv`,
    updateCourseTotalDurationUrl: `${API_URL}/api/update-course-total-duration`,

    checkBulkEmailVerificationStatusUrl: `${API_URL}/api/check-bulk-email-verification`,
    startBulkEmailVerificationUrl: `${API_URL}/api/start-bulk-email-verification`,
    cancelBulkEmailVerificationUrl: `${API_URL}/api/cancel-bulk-email-verification`,
    checkBulkEmailDnsStatusUrl: `${API_URL}/api/check-bulk-email-dns-status`,
    createBulkEmailAwsSesIdentityUrl: `${API_URL}/api/create-bulk-email-aws-ses-identity`,

    verifyOpenAiKey : `${API_URL}/api/verifyOpenAiKey`,
    retrieveTransactionalEmailsUrl:`${API_URL}/api/retrieve-transactional-emails`,
    sendTransactionalEmailsUrl: `${API_URL}/api/send-transactional-email`,
    applyEmailBrandingUrl: `${API_URL}/api/apply-email-branding`,
    generateAiTitle: `${API_URL}/api/ai-title`,
    generateAiText: `${API_URL}/api/ai-text`,
    aiCatalogInsights: `${API_URL}/api/ai-catalog-insights`,

    aiCourseOutline: `${API_URL}/api/ai-course-outline`,
    generateAiImageUrl: `${API_URL}/api/ai-image/generate`,
    generateAiImageExamplePromptsUrl: `${API_URL}/api/generate-image-suggestions`,
    saveAiImageUrl: `${API_URL}/api/ai-image/save`,
    generateAiReviewAnswerDraftUrl: `${API_URL}/api/ai-review-answer-draft`,
    generateAiPrice: `${API_URL}/api/ai-price`,
    aiQuiz: `${API_URL}/api/ai-quiz`,
    aiQuizQuestion: `${API_URL}/api/ai-quiz-question`,
    aiQuizAnswer: `${API_URL}/api/ai-quiz-answer`,
    aiQuizMultiAnswers: `${API_URL}/api/ai-quiz-multi-answers`,
    aiCommunityComment: `${API_URL}/api/ai-community-comment`,
    communityThreadSummary: `${API_URL}/api/community/thread-summary`,
    aiAnswer: `${API_URL}/api/ai-answer`,
    aiUrlPath: `${API_URL}/api/ai-url-path`,
    generateAiRichText: `${API_URL}/api/ai-rich-text`,
    generateAiCourseFeatures: `${API_URL}/api/ai-course-features`,
    generateAiCourseFaqs: `${API_URL}/api/ai-faq`,
    aiThemes: `${API_URL}/api/ai-themes`,
    generateAiVideo: `${API_URL}/api/ai-video`,
    generateAiAssignment: `${API_URL}/api/ai-assignment`,
    generateAiDigitalDownload: `${API_URL}/api/ai-digital-download`,
    generateAiAudio: `${API_URL}/api/ai-audio`,
    generatePageBuilderText: `${API_URL}/api/ai-page-builder`,
    aiPageHeaderSection: `${API_URL}/api/ai-page-builder-header-section`,
    aiPageBuilderBenefitsSection: `${API_URL}/api/ai-page-builder-benefits-section`,
    aiPageBuilderFAQSection: `${API_URL}/api/ai-page-builder-faq-section`,
    aiPageNewsLetterSection: `${API_URL}/api/ai-page-builder-news-letter-section`,
    aiPageCtaSection: `${API_URL}/api/ai-page-builder-cta-section`,
    aiPageHighlightedBoxSection: `${API_URL}/api/ai-page-builder-highlighted-box-section`,
    aiPageBuilderRichTextSection: `${API_URL}/api/ai-page-builder-rich-text-section`,
    aiPageBuilderImageSection: `${API_URL}/api/ai-page-builder-image-section`,
    exportActivityLogCsvUrl: `${API_URL}/api/export-activity-log-csv`,
    aiAssessmentQuestionTag: `${API_URL}/api/ai-assessment-question-tag`,
    aiAssessmentOptionsHint: `${API_URL}/api/ai-assessment-options-hint`,
    aiAssessmentFeedbackForCorrectAnswer: `${API_URL}/api/ai-correct-answer-feedback`,
    aiAssessmentQuestion: `${API_URL}/api/ai-assessment-question`,
    aiAssessmentOptionsAnswer: `${API_URL}/api/ai-assessment-options-answer`,
    generateAiAssessment: `${API_URL}/api/ai-assessment`,
    aiGenerateTrueFalseQuestion: `${API_URL}/api/ai-generate-true-false-question`,
    aiGenerateReorderQuestion: `${API_URL}/api/ai-generate-reorder-question`,
    aiGenerateReorderQuestionAnswers: `${API_URL}/api/ai-generate-reorder-question-answers`,
    aiGenerateTextOptionsQuestion: `${API_URL}/api/ai-generate-text-options-question`,
    aiGenerateTextOptionsQuestionAnswers: `${API_URL}/api/ai-generate-text-options-question-answers`,
    aiGenerateFillInTheBlanksQuestion: `${API_URL}/api/ai-generate-fill-in-the-blanks-question`,
    aiGenerateMatchingQuestion: `${API_URL}/api/ai-generate-matching-question`,
    aiGenerateOpenEndedAnswerQuestion: `${API_URL}/api/ai-generate-open-ended-answer-question`,
    aiGenerateMatchingQuestionAnswerPairs: `${API_URL}/api/ai-generate-matching-question-answers`,
    aiGenerateDropdownOptionsQuestion: `${API_URL}/api/ai-generate-dropdown-options-question`,
    aiGenerateDropdownOptionsQuestionAnswers: `${API_URL}/api/ai-generate-dropdown-options-question-answers`,
    aiGenerateImageQuestion: `${API_URL}/api/ai-generate-image-question`,

    // Zoom Integration endpoints
    zoomOAuthInitiate: `${API_URL}/api/zoom/auth`,
    zoomSignature: `${API_URL}/api/zoom/signature`,
    zoomZAKToken: `${API_URL}/api/zoom/zak`,
    zoomHostEmail: `${API_URL}/api/zoom/host-email`,
    zoomStartSession: `${API_URL}/api/zoom/meetings/start-session`,
    zoomStartWebinar: `${API_URL}/api/zoom/webinars/start-session`,
    zoomEndSession: `${API_URL}/api/zoom/meetings/end-session`,
    zoomEndWebinar: `${API_URL}/api/zoom/webinars/end-session`,
    zoomCheckMeeting: `${API_URL}/api/zoom/meetings/check`,

    exportStudentProgressCsvUrl: `${API_URL}/api/export-student-progress-csv`,
    getRandomQuestionBankQuestions: `${API_URL}/api/random-question-bank-questions`,
  },

  algolia: {
    app_id: `MLN7U6GUV2`,
    search_key: `c823492fdf909629bd74a297babf9be9`,
  },

  openSearch: {
    searchUsersUrl: `${API_URL}/api/search/users`,
    searchLessonsUrl: `${API_URL}/api/search/lessons`,
    searchQandaUrl: `${API_URL}/api/search/qanda`,
    searchLessonNotesUrl: `${API_URL}/api/search/lesson-notes`
  },
  tracking: {
    firestoreLogging: false,
  },
};
